export const ACTION_ITEM_ENTITY_TYPE = "action-item";
/** The conversation summaries an action item captured from a conversation links to. */
export const CONVERSATION_SUMMARY_ENTITY_TYPE = "summary";
